import React, { useState } from "react";
import useCaPrice from "@/lib/useCaPrice";
import PriceHistoryModal from "@/components/PriceHistoryModal";

export default function CaPriceBadge({ compact = false }) {
  const { price, botPrice, isLive, source, loading } = useCaPrice();
  const [histOpen, setHistOpen] = useState(false);
  if (!price) return null;
  return (
    <>
      <button
        type="button"
        onClick={() => setHistOpen(true)}
        title={`${source}${isLive ? "" : " — showing last saved price"} · click for price history`}
        className="hidden md:inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-mono font-semibold transition-colors hover:bg-white/70"
        style={{ background: "rgba(15,18,38,0.05)", color: "#0F1226" }}
        data-testid="ca-price-badge"
      >
        <span
          className={`inline-block w-1.5 h-1.5 rounded-full ${loading ? "animate-pulse" : ""}`}
          style={{ background: isLive ? "#00863A" : "#B45309", boxShadow: isLive ? "0 0 0 3px rgba(0,134,58,0.15)" : "0 0 0 3px rgba(180,83,9,0.15)" }}
        />
        <span style={{ color: "#8D1CEB" }}>CA ${Number(price).toFixed(2)}</span>
        {botPrice != null && (
          <>
            <span className="text-ink-3/50">·</span>
            <span style={{ color: "#15DCAC" }} data-testid="bot-price-badge">BOT ${Number(botPrice).toFixed(2)}</span>
          </>
        )}
      </button>
      <PriceHistoryModal open={histOpen} onClose={() => setHistOpen(false)} currentCa={price} currentBot={botPrice} />
    </>
  );
}
